// AwareHub TMS - Content data (exact content from client's website)
// Images are relevant stock placeholders until final clinic photos are supplied.

export const LOGO_URL = "/site-images/logo.png";

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about", children: [{ label: "Meet The Team", path: "/about/team" }] },
  { label: "TMS", path: "/tms" },
  { label: "Accelerated TMS", path: "/accelerated-tms" },
  { label: "Esketamine", path: "/esketamine" },
  { label: "Fees", path: "/fees" },
  { label: "FAQ", path: "/faq" },
  { label: "News", path: "/news" },
  { label: "Contact", path: "/contact" },
];

// All images below are AwareHub's own photos, downloaded from awarehubtms.com.au
// and hosted locally under /site-images/.
export const IMAGES = {
  heroClinic: "/site-images/blob-hero.jpg", // woman receiving TMS treatment (original hero)
  wellnessStudio: "/site-images/blob-750.jpg", // TMS treatment in room
  tealChairs: "/site-images/clinic-600A0514.jpg", // clinician consultation
  loveseat: "/site-images/psychology.jpg", // therapy session
  desk: "/site-images/friendlies-building.jpg", // About "A Holistic" section — The Friendlies Medical Suites building
  reception: "/site-images/reception-2.webp", // reception - staff greeting clients (Bondi Junction)
  pillows: "/site-images/clinic-jpp007.jpg", // reception desk
  stones: "/site-images/clinic-jpp002.jpg", // AwareHub reception hallway (Fees)
  brain1: "/site-images/clinic-600A0514.jpg", // AwareHub clinician / assessment (TMS)
  brain2: "/site-images/psychology.jpg",
  clinicInterior: "/site-images/clinic-jpp007.jpg", // reception on phone
  clinicInterior2: "/site-images/clinic-jpp002.jpg", // reception hallway
  ocean: "/site-images/stock-84943.jpg", // calm forest path (used behind quote)
  beach: "/site-images/friendlies-building.jpg", // News — The Friendlies Medical Suites, Bundaberg
  benefitSafe: "/site-images/stock-zv23.jpg", // older woman heart-hands
  benefitCost: "/site-images/stock-pmeq.jpg", // medical icons
  benefitTga: "/site-images/stock-bxm.jpg", // profile / neuroplasticity
  research: "/site-images/stock-nb076.jpg", // brain analysis on laptop (research/mapping)
  friendliesBuilding: "/site-images/friendlies-building.jpg", // The Friendlies Medical Suites, Bundaberg (image 17166)
  bundabergInternal: "/site-images/reception-a1463.webp", // AwareHub reception (blue fluted-wall)
  esketamine17164: "/site-images/esketamine-17164.jpg", // 17164 - treatment room (client-supplied)
  consultation0576: "/site-images/consultation-0576.webp", // 600A0576 - two-person consultation (client-supplied)
  sydneyReception: "/site-images/reception-a1463.webp", // Bondi Junction reception (blue fluted-wall)
  contactReception: "/site-images/reception-1.webp", // reception with timber slats (contact section)
  receptionDeskDuo: "/site-images/reception-desk-duo.webp", // two staff at reception desk (About - Expanding Regional Access)
  greenWall: "/site-images/green-wall.webp", // reception corridor with green wall (TMS strip)
  treatmentRoom15856: "/site-images/treatment-room-15856.jpg", // treatment room recliner with artwork (TMS strip)
  communityZone: "/site-images/community-zone.webp", // breakout/community space (TMS strip)
  quietZone: "/site-images/quiet-zone.webp", // quiet zone with rattan pouf (Fees)
  relaxHeadphones: "/site-images/headphones-relax-096.webp", // JPP_AwareHub_096 - client relaxing with headphones (Esketamine protocol)
};

// Per-page metadata (copied from awarehubtms.com.au)
export const META = {
  home: {
    title: "Effective TMS Therapy in Sydney for Depression",
    description:
      "Discover Sydney TMS services for depression, anxiety and OCD. Transform your mental health with our advanced TMS therapy.",
  },
  about: {
    title: "AwareHub TMS - Sydney TMS, TMS for Depression, Anxiety & OCD",
    description:
      "Servicing the Sydney TMS community, offering TMS for depression, anxiety & OCD. Located at Bondi Junction and just minutes from Bondi Beach and Sydney CBD.",
  },
  team: {
    title: "Meet The Team | Bespoke Mental Health Clinic Sydney | AwareHub",
    description:
      "We are the AwareHub Team - mental health professionals working together with passion and expertise to bring a creative, innovative and holistic approach to working with people.",
  },
  faq: {
    title: "AwareHub TMS - Sydney TMS, TMS for Depression, Anxiety & OCD",
    description:
      "Servicing the Sydney TMS community, offering TMS for depression, anxiety & OCD. Located at Bondi Junction and minutes from Bondi Beach and Sydney CBD.",
  },
  tms: {
    title: "AwareHub TMS - Depression, Anxiety & OCD, Mental Health Clinic, TMS",
    description:
      "AwareHub is a bespoke mental health clinic offering TMS for depression, anxiety & OCD. Located at Bondi Junction and minutes from Bondi Beach & Sydney CBD.",
  },
  fees: {
    title: "AwareHub TMS in Sydney, New South Wales",
    description:
      "Servicing the Sydney TMS community, offering TMS for depression, anxiety & OCD. Located at Bondi Junction and minutes from Bondi Beach & Sydney CBD.",
  },
  news: {
    title: "AwareHub TMS in Sydney, New South Wales",
    description:
      "Our team of experienced healthcare professionals servicing the TMS Sydney and Bundaberg communities are dedicated to providing the highest quality care.",
  },
  contact: {
    title: "AwareHub TMS in Sydney, New South Wales",
    description:
      "Servicing the Sydney TMS community, offering TMS for depression, anxiety & OCD. Located at Bondi Junction and just minutes from Bondi Beach and Sydney CBD.",
  },
};

// Copied from awarehub.com.au/about-us/team/ (member bios live in src/data/team.json)
export const TEAM_PAGE = {
  eyebrow: "AwareHub Mental Health Clinic",
  title: "Meet The Team",
  bullets: [
    "Psychiatrists, psychologists, neuropsychologist",
    "Speech and occupational therapists, dietician",
    "Specialists in Esketamine and TMS treatment",
    "NDIS providers",
  ],
  gridTitle: "Our Team",
  heroImage: "/site-images/team/team-hero.webp",
};

export const CONTACT = {
  phone: "1300 029 273",
  phoneHref: "tel:1300029273",
  hours: [
    { day: "Mon – Fri", time: "8:30 am – 5:30 pm" },
    { day: "Sat – Sun", time: "Closed" },
    { day: "Public holidays", time: "Closed" },
  ],
  brochureUrl:
    "https://awarehub.com.au/wp-content/uploads/TMS-consumer-brochure-December2024.pdf",
  locations: [
    {
      name: "AWAREHUB SYDNEY TMS & ESKETAMINE CLINIC",
      address: "Suite 703/1 Newland Street, Bondi Junction, 2022, NSW, Australia",
      email: "tms@awarehub.com.au",
    },
    {
      name: "AWAREHUB BUNDABERG TMS & ESKETAMINE CLINIC",
      address: "The Friendlies Medical Suites, 70-72 Crofton Street, Bundaberg, 4670, QLD, Australia",
      email: "BundabergTMS@awarehub.com.au",
    },
  ],
  socials: [
    { label: "Facebook", url: "https://www.facebook.com/awarehubclinic" },
    { label: "Instagram", url: "https://www.instagram.com/awarehub_clinic/" },
    { label: "LinkedIn", url: "https://www.linkedin.com/in/lisa-myers-psychiatrist/" },
    { label: "TikTok", url: "https://www.tiktok.com/@awarehub" },
    { label: "YouTube", url: "https://www.youtube.com/channel/UCkY-LMLaXAuk9996bQNEqjA" },
  ],
};

export const HOME = {
  eyebrow: "BUNDABERG & SYDNEY TMS CLINIC",
  heroTitle:
    "Offering TMS for depression, anxiety and OCD. Now open in Bundaberg.",
  heroSubtitle:
    "AwareHub has been successfully treating the TMS Sydney community since 2022, and is now open in Bundaberg.",
  whatIsTitle: "What is TMS?",
  whatIsIntro:
    "TMS is an effective treatment that has been used for approximately thirty years to treat a range of mental health and neurological conditions.",
  whatIsParagraphs: [
    "TMS is a simple, non-invasive procedure that uses magnetic pulses to either stimulate or inhibit neurons in specific areas of the brain to treat depression, anxiety, OCD and other presentations.",
    "Research supports using TMS to treat a range of other conditions, such as chronic pain, neuropathic pain, migraines, post-traumatic stress disorder (PTSD), tinnitus, substance dependence and autism spectrum disorder (ASD).",
    "TMS is typically used when standard treatments haven't worked or have caused intolerable side effects. Some clients prefer a non-medication approach to manage their mental health.",
    "TMS is faster acting than medication. Studies show that 3 out of 4 clients with depression respond well to TMS.",
    "TMS has fewer side effects than many antidepressant medications.",
    "TMS does not cause 'personality changes' or cognitive side effects. You remain awake and alert throughout the treatment, can drive after and immediately get on with your day.",
  ],
  revolutionaryTitle: "A revolutionary, drug-free treatment",
  revolutionaryCards: [
    {
      title: "Expert Care with Proven Results",
      body: "Our dedicated and experienced team of nurses and doctors have been providing the highest quality care to our Sydney and Bundaberg communities since 2021. Many of our clients have achieved successful outcomes from both TMS and Esketamine.",
      image: IMAGES.wellnessStudio,
    },
    {
      title: "Accelerated TMS Protocols and Personalised Treatment Plan",
      body: "Because no two clients are the same, a customised treatment plan is developed to meet your needs. We offer accelerated TMS protocols to fast-track your depression treatment. A typical course of TMS for depression involves daily treatments for 4 to 6 weeks, but accelerated TMS can be delivered in just one week!",
      image: IMAGES.clinicInterior,
    },
  ],
  benefitsTitle: "Achieve Optimal Mental Health with AwareHub TMS",
  benefits: [
    { title: "A safe treatment with no long-term side effects.", icon: "ShieldCheck", image: IMAGES.benefitSafe },
    { title: "Bulk-billed TMS for treatment-resistant depression", icon: "PiggyBank", image: IMAGES.benefitCost },
    { title: "TGA-approved for Resistant-Depression and OCD.", icon: "BadgeCheck", image: IMAGES.benefitTga },
  ],
  quote: "Work on yourself and the rest will follow. Your life only gets better when you do.",
  quoteAuthor: "Dr Lisa Myers, Psychiatrist",
  enquireTitle: "Enquire today to see if TMS is right for you.",
  enquireBody:
    "TMS is an approved treatment for treatment-resistant depression and OCD. It has proven benefits and can be used in many other mental health and neurological conditions. TMS has a low side effect profile, doesn't require hospitalisation, anaesthesia or a recovery period.",
  videoTitle: "Understanding TMS",
  videoId: "BbpKikW-mkA",
  videoCaptionTitle: "DR LISA MYERS & TMS",
  videoCaptionBody:
    "AwareHub founder and psychiatrist, Dr Lisa Myers, shares her insights about TMS for depression, anxiety & OCD.",
};

export const TESTIMONIALS_TITLE = "Here's what our clients are saying about TMS";
export const TESTIMONIALS = [
  {
    quote:
      "When I first started TMS I was in a very unsafe place mentally, where I felt my life was at risk. However, since commencing TMS and attending consistently, and with the support of the clinic, TMS has made me feel a lot safer. It has made me happier, and more capable to living my life to the fullest.",
    author: "YD 18",
  },
  {
    quote:
      "Feeling a sense of calm, and since starting TMS I have noticed a decrease in negative thought pattern. My anxiety driven responses are less. I am able to remain calmer and objective in situations that would previously have triggered me. Although I still have some brain fog, my thoughts are clearer.",
    author: "JS 45",
  },
  {
    quote:
      "TMS improved my mood significantly. I felt happy and a lot calmer just after a few sessions. After 15 sessions I noticed my energy levels increase, and my sleep pattern improving.",
    author: "AL 26",
  },
  {
    quote:
      "The very first time I had TMS, I felt good, I went to the beach and swam in the sea and felt like a million dollars.",
    author: "DM 73",
  },
  {
    quote:
      "This process is incredibly helpful to kickstart positive mental change. TMS has helped me better understand and regulate how I feel.",
    author: "OC 16",
  },
  {
    quote:
      "TMS helped me during the relapse of my depression and anxiety. For the time it takes an antidepressant to take effect, TMS made it easier to cope with my anxiety and depression. I was very lucky that my job enabled me to come to TMS because it would have been really hard otherwise to stay consistent with my sessions.",
    author: "EH 25",
  },
  {
    quote:
      "TMS has helped me in the most incredible way with my depression. TMS has helped my anxious feeling, like no other antidepressant has.",
    author: "DF 51",
  },
  {
    quote:
      "TMS had a definite positive impact on my depression. When I started I had very low mood, and now I am seeing improvement in that, together with my overall wellbeing.",
    author: "ML 52",
  },
];

export const ABOUT = {
  title: "A Specialised Mental Health Clinic Offering Advanced Treatment Options",
  heroImage: IMAGES.reception,
  intro:
    "AwareHub TMS and Esketamine Clinics were founded in Sydney. We specialise in advanced, evidence-based therapies for treatment-resistant depression, complex mental health conditions, and people unable to tolerate medication. When standard care fails to achieve results, we provide proven, non-invasive clinical alternatives.",
  sections: [
    {
      heading: "Individualised & Multidisciplinary",
      image: IMAGES.clinicInterior,
      paragraphs: [
        "We tailor every care plan to suit your needs. Our specialist psychiatrists and registered nurses work together to design, deliver, and closely monitor your specific treatment protocol.",
      ],
    },
    {
      heading: "Patient-Centred Community",
      image: IMAGES.consultation0576,
      paragraphs: [
        "Clinical excellence begins with active listening. We foster a compassionate, respectful environment where you are genuinely heard and involved in every decision.",
      ],
    },
    {
      heading: "Expanding Regional Access",
      image: IMAGES.desk,
      paragraphs: [
        "Established at our Sydney headquarters, AwareHub is dedicated to extending specialised mental health treatments, including TMS and Esketamine, into regional communities where advanced care is needed most.",
      ],
      boldLine: "New locations coming soon in Gladstone & Hervey Bay!",
    },
    {
      heading: "Our Team",
      image: IMAGES.receptionDeskDuo,
      paragraphs: [
        "Our AwareHub TMS and Esketamine teams comprise dedicated, caring, and experienced professionals, including psychiatrists, psychologists and registered nurses. We are committed to providing exceptional care and access to advanced, evidence-based treatments.",
      ],
      linkLine: { before: "Meet the entire AwareHub team ", label: "HERE", after: ".", to: "/about/team" },
    },
    {
      heading: "Our Sydney & Bundaberg Communities",
      image: IMAGES.tealChairs,
      paragraphs: [
        "Located in Bondi Junction (Sydney) and Bundaberg, our TMS and Esketamine clinics are designed as welcoming spaces where every client feels part of a caring, supportive community.",
      ],
    },
  ],
};

export const FAQ_PAGE = {
  title: "TMS Frequently Asked Questions",
  intro:
    "Please reach us at reception@awarehub.com.au if you cannot find an answer to your question.",
  faqs: [
    {
      q: "How do I make an appointment for TMS or Esketamine at AwareHub?",
      a: [
        "Both TMS and Esketamine (Spravato®) are specialised psychiatric treatments that require a referral from your GP or psychiatrist before your initial consultation.",
        "To get started: 1) Ask your doctor or psychiatrist to send a referral addressed to AwareHub. 2) Email your referral to TMS@awarehub.com.au or contact our team directly at 1300 0 AWARE (1300 029 273) if you have any questions. 3) Once we receive your referral, our clinical intake team will reach out within 48 hours to book your initial specialist assessment.",
      ],
    },
    {
      q: "What is your cancellation policy?",
      a: ["We require at least 2 business days' notice to cancel or reschedule an appointment. Late cancellations or missed appointments may incur the full appointment fee."],
    },
    {
      q: "Can I bring a support person?",
      a: ["Yes, in most cases you are welcome to bring a family member, carer, or support person. Please contact us if you would like to arrange bringing a support person with you for Esketamine treatment."],
    },
    {
      q: "What should I do in an emergency or crisis?",
      a: ["AwareHub is an outpatient clinic and does not provide immediate emergency or crisis care. If you require urgent assistance, please call 000, contact Lifeline on 13 11 14, your GP or present to your nearest hospital emergency department."],
    },
    {
      q: "What is Esketamine therapy?",
      a: ["Esketamine is a TGA-approved prescription nasal spray administered alongside an oral antidepressant for adults with treatment-resistant depression. It acts on the brain's glutamate pathways to help restore neural connections and improve mood."],
    },
    {
      q: "How is Esketamine administered?",
      a: ["Esketamine is self-administered as a nasal spray strictly within our clinic under direct medical and nursing supervision."],
    },
    {
      q: "Can I drive home after an Esketamine session?",
      a: ["No. Due to temporary drowsiness or light-headedness, you must arrange transport home with a friend, family member, or ride-share service, and you must not drive or operate machinery until the following day."],
    },
    {
      q: "Is TMS covered by Medicare?",
      a: ["Yes. Initial courses of TMS for treatment-resistant depression are fully bulk-billed under Medicare for eligible patients 18 and older (up to 35 sessions), meaning no out-of-pocket costs for these treatment sessions. Psychiatrist assessment and review consultations attract Medicare rebates."],
    },
    {
      q: "Are DVA, Workcover, or NDIS accepted?",
      a: ["Yes. AwareHub is a registered NDIS provider. We also accept eligible DVA cardholders and approved Workcover (including iCare NSW and Workcover QLD) claims for structured treatment programs like TMS and Esketamine."],
    },
    {
      q: "What is the cost of Accelerated TMS?",
      a: ["Because Medicare limits daily billable session limits, 15 sessions in the 5-day accelerated protocol fall outside standard Medicare coverage. The remaining 35 sessions are bulk-billed, capping the total patient out-of-pocket cost at $750 for the full 50-session course."],
    },
    {
      q: "Why Choose TMS?",
      a: [
        "Transcranial Magnetic Stimulation (TMS) has the Australian Therapeutic Goods Administration's (TGA) approval as a treatment for resistant depression and obsessive-compulsive disorder (OCD). TMS has also demonstrated efficacy in treating anxiety, PTSD, migraines, substance disorders, chronic pain, nerve pain, dementia and symptoms of autism spectrum disorder (ASD).",
        "TMS is an excellent option if medication has not been effective or well tolerated due to side effects. TMS is most effective when combined with a healthy lifestyle. TMS demonstrates a 70% response rate in depression treatment. It is a cost-effective and revolutionary treatment that improves brain functioning and connectivity and stimulates neuroplasticity.",
      ],
    },
    {
      q: "Quick Facts about TMS",
      list: [
        "Safe",
        "Convenient",
        "Less side effects than most medications",
        "No personality changes or cognitive side effects",
        "Fast",
        "Cost-effective",
        "TGA approved",
        "Bulk-billed for treatment-resistant depression and no out-of-pocket fees apply",
        "Wide spread use and efficacy",
        "Observed benefits in chronic pain, tinnitus, substance use, cerebral palsy, dementia, PTSD, ADHD, ASD",
      ],
    },
    {
      q: "Is TMS right for me?",
      a: [
        "Transcranial Magnetic Stimulation (TMS) is an exciting and revolutionary approach to treating psychiatric and neurological conditions without medication. TMS has a faster onset of action and a very low side effect profile compared to most medications. A typical course of TMS for depression treatment includes 35 treatments. TMS is indicated where medications have failed, are only minimally effective or have caused unwanted side effects. TMS alters 'faulty' brain connections and activity, helping the brain to function better again.",
      ],
    },
    {
      q: "How does TMS Work?",
      a: [
        "The principle behind TMS is that magnetic pulses focused on a specific brain region can be used to stimulate or inhibit brain cells. TMS applied at high frequency stimulates brain activity. TMS applied at low frequency reduces brain activity. By targeting abnormal activity (too high or too low) in certain brain regions associated with psychiatric and neurological conditions, TMS can be used to restore healthy levels of brain function.",
        "TMS also stimulates neuroplasticity which means it creates new nerve pathways and improves the functioning and connectivity of existing neurons and brain areas. TMS modifies and rebalances activity in the brain networks that have become altered causing presenting symptoms.",
        "Major depressive disorder is the most common condition treated with TMS. Activity in the left frontal area of the brain, in a region called the dorsolateral prefrontal cortex, is reduced in patients with depression. High frequency TMS aimed at the left prefrontal cortex is used to return normal activity to that part of the brain and thereby eliminate or reduce the symptoms of depression.",
        "The safety and efficacy of TMS for treating depression has been established in several well controlled research studies including a study sponsored by the National Institute of Mental Health. Since 2008 over 20,000 patients have undergone TMS treatment. There are over 30 studies demonstrating the efficacy of TMS as treatment for depression in adults.",
      ],
    },
    {
      q: "How does TMS work for OCD?",
      a: [
        "TMS treatment for OCD utilises a low frequency stimulation to directly reduce activity in the area of the brain responsible for OCD symptoms. Response rates for OCD using TMS treatments are approximately 66%. TMS treatment for OCD uses a specialised coil known as a Double Cone Coil that has the ability to target deeper brain structures, such as those implicated in OCD neuropathology.",
      ],
    },
    {
      q: "Is TMS safe in pregnancy?",
      a: [
        "Major depressive disorder (MDD) during pregnancy is a major concern. It is estimated that 13% of women suffer from depression during pregnancy. Pregnant females with MDD are less likely to seek prenatal care and are at higher risk of pregnancy-related complications (preterm birth, lower birth weight, and pre-eclampsia). The resulting maternal depression is known to have long-term impacts on maternal-infant bonding and child development.",
        "Conclusions from reviews of the current literature indicated that both high- and low-frequency TMS can be used during all trimesters of pregnancy with a significant response in depressive symptom reduction. TMS offers a promising alternative to current treatment options for managing MDD during pregnancy, and no evidence suggests detrimental effects on the foetus. Certainty awaits large, standardised studies and long-term multi-centre trials.",
      ],
    },
    {
      q: "What is peripheral TMS?",
      a: [
        "This is an advanced, novel treatment for the management of pain conditions by stimulating the target area with magnetic pulses. Peripheral TMS is a short and rapidly effective treatment to alleviate pain, by encouraging the body to promote natural healing. It can be used for a number of conditions, including neuropathic pain, musculoskeletal and spinal disorders: Cervical pain, frozen shoulder, chronic back pain, sciatica, spondylitis, sport injuries, rheumatoid/degenerative arthritis.",
      ],
    },
    {
      q: "How is TMS different to ECT?",
      a: [
        "Electro-convulsive therapy (ECT) entails electrically induced seizures given under an anaesthetic in hospital. However, TMS therapy is conducted in the clinic and it stimulates brain regions using brief magnetic pulses at an amplitude similar to that used in MRI systems. ECT may cause severe side effects, including memory loss, while TMS has no negative effects on memory, and is generally well-tolerated.",
      ],
    },
    {
      q: "Is TMS different to medications?",
      a: [
        "Yes. TMS is a drug-free treatment that has less side effects than antidepressants. TMS is often effective when medications have failed. TMS can be stopped at any time with no withdrawal symptoms.",
      ],
    },
    {
      q: "How will I know TMS is working?",
      a: [
        "Your presenting symptoms will start to improve and others might remark that you appear better. Your scores on standardised questionnaires of mood and anxiety will also demonstrate an improvement.",
      ],
    },
    {
      q: "Quick facts about the procedure?",
      list: [
        "TMS causes minimal discomfort.",
        "You remain awake and alert through the procedure.",
        "You can read, rest and relax or talk to the clinician throughout your treatment.",
        "You can resume activities directly following the treatment.",
        "During the treatment you will hear a clicking noise and feel a tapping sensation on your scalp.",
        "A clinician will always be with you.",
        "You can stop the treatment at any time.",
      ],
    },
    {
      q: "Does TMS have side effects?",
      list: [
        "Clients can resume normal daily activities immediately following a treatment session.",
        "The most common side effect is a mild headache and scalp discomfort in the area of the treatment site. This typically occurs only in the first week of treatment. Any pain symptoms are generally relieved with a mild analgesic e.g. Panadol.",
        "There is an exceptionally rare risk of a seizure. The risk of a seizure is in fact comparable to that of antidepressant medications.",
        "No long-term side effects have been identified.",
        "TMS does not cause memory loss or personality changes.",
        "TMS has fewer side effects than antidepressants.",
      ],
    },
    {
      q: "Do I still need my medication?",
      a: [
        "Yes, unless advised otherwise, you should remain on your medication for the duration of the treatment. Medication is helpful to prevent relapse following the tapering and cessation of TMS. There are instances where medication can be reduced and ceased whilst undergoing TMS. Medications can also be switched whilst undergoing TMS and new options of treatment can be trialed. Any stopping of medication or changes to your current treatment need to be done in consultation with your treating doctor.",
      ],
    },
    {
      q: "Do I need to consult my doctor?",
      a: [
        "Yes, your psychiatrist and/or GP remain responsible for your care. Our team will be responsible for administering and overseeing your TMS treatment. We will provide your doctor with regular written updates regarding your treatment. Your treating doctor remains your primary contact person, but you should always raise any concerns regarding your TMS treatment with one of our team members.",
      ],
    },
  ],
};

export const TMS_PAGE = {
  referralTitle: "Download a TMS Referral Form here for your Doctor",
  referralUrl:
    "https://img1.wsimg.com/blobby/go/cc802e31-1d95-429d-8fb9-d39e271b285e/downloads/TMS%20Referral%20June%202023%20v3%20-%20Fillable.pdf?ver=1754614173680",
  sectionTitle: "TMS TREATMENT EXPLAINED",
  steps: [
    {
      title: "Step 1: Referral and Booking",
      body: "Have your GP or psychiatrist send a referral to AwareHub TMS. Our team will contact you within 48 hours to book your initial appointment with our psychiatrist.",
    },
    {
      title: "Step 2: Assessment and Setup (Mapping session / Resting motor threshold determination)",
      body: "Meet with our psychiatrist to discuss your care and customise your treatment protocol. At your first TMS appointment, we will use simple measurements to determine the correct coil placement and treatment dosage.",
    },
    {
      title: "Step 3: Active Treatment (3-5 treatments/week)",
      body: "Undergo your acute course of treatment with constant monitoring by our experienced nursing team and supervising psychiatrist.",
    },
    {
      title: "Step 4: Maintenance Treatment",
      body: "To maintain your progress and prevent relapse, your sessions are gradually tapered down to once weekly or fortnightly.",
    },
  ],
  helpfulInfoTitle: "Helpful Information",
  helpfulInfo: [
    "TMS treatments are quick and range from under 1 minute to 19 minutes, depending on your treatment protocol.",
    "You can drive immediately after your TMS session.",
    "There is no downtime needed after a treatment.",
    "Accelerated TMS is available and can fast-track your recovery journey.",
  ],
};

export const FEES_PAGE = {
  title: "AwareHub Bundaberg & Sydney TMS Clinics",
  subtitle: "Fees & Rebates",
  items: [
    {
      heading: "Medicare-funded TMS for Depression",
      body: "Eligible patients with treatment-resistant depression may be able to access TMS under Medicare, subject to Medicare eligibility and the relevant clinical requirements.",
    },
    {
      heading: "Accelerated TMS – Fees & Medicare",
      body: "An accelerated 5-day course involves 50 TMS treatment sessions. Medicare rebates are available for eligible sessions, with the remaining sessions privately billed. The total out-of-pocket cost for the 50-session accelerated course is $750.",
    },
    {
      heading: "Private / Non-Medicare TMS",
      body: "For patients who are not eligible for Medicare-funded TMS, private TMS treatment is available from $50 per session, depending on the treatment course.",
    },
    {
      heading: "Psychiatrist Progress Reviews",
      body: "Patients undergoing TMS may have regular progress reviews with our psychiatrist to monitor treatment response and progress. These consultations are billed at our standard clinic rates, with Medicare rebates available where applicable.",
    },
    {
      heading: "NDIS",
      body: "AwareHub is a registered NDIS provider and may provide TMS and other eligible therapeutic supports for NDIS participants, subject to individual plans and funding arrangements.",
    },
    {
      heading: "DVA & WorkCover",
      body: "TMS may be available to eligible DVA clients and approved WorkCover participants, subject to the relevant funding and treatment approvals.",
    },
  ],
  highlights: [
    "Bulk-billed TMS for treatment-resistant depression — no out-of-pocket costs.",
    "DVA, Work Cover (iCare NSW & Workcover QLD) and NDIS accepted.",
  ],
};

export const NEWS_PAGE = {
  featured: {
    title:
      "Bundaberg Now announces AwareHub expansion into Bundaberg TMS for depression",
    subtitle: "AwareHub brings revolutionary TMS treatments to Bundaberg.",
    linkLabel: "Click here to read the Bundaberg Now story",
    linkUrl:
      "https://www.bundabergnow.com/2024/11/13/awarehub-mental-health-clinic-expands-to-region/",
  },
  gladstone: {
    eyebrow: "Announcement",
    title: "AwareHub is Coming to Gladstone!",
    subtitle:
      "We're excited to announce that AwareHub is planning to bring TMS and Esketamine treatments to Gladstone, providing greater access to specialised mental health care closer to home. Stay tuned for updates!",
    image: IMAGES.receptionDeskDuo,
  },
  articles: [
    {
      source: "BUNDABERG TODAY — 20 November 2024",
      image: IMAGES.beach,
      body: "Sydney based AwareHub expands into Bundaberg with revolutionary TMS treatments.",
      linkLabel: "Download PDF",
      linkUrl:
        "https://img1.wsimg.com/blobby/go/cc802e31-1d95-429d-8fb9-d39e271b285e/Bundaberg%20Today%2020.11.2024.pdf",
    },
    {
      source: "THE DAILY TELEGRAPH REPORT by Angela Saurine",
      image: IMAGES.heroClinic,
      body: "Danielle Franco's life has turned around since discovering TMS for depression at AwareHub.",
      linkLabel: "Download PDF",
      linkUrl:
        "https://img1.wsimg.com/blobby/go/cc802e31-1d95-429d-8fb9-d39e271b285e/Bondi%20Junction%20clinic%20using%20new%20therapies%20to%20h.pdf",
    },
    {
      source: "TMS 9 News Report by Mikala Theocharous",
      image: IMAGES.tealChairs,
      body: "Targeted non-invasive procedure helping depression patients.",
      linkLabel: "Click here to read the 9 News report on TMS for depression",
      linkUrl:
        "https://amp.9news.com.au/article/48adb021-2cb1-4d80-936d-1dbfcb0b39b7",
    },
  ],
};

export const REVIEWS_META = { rating: "5.0", label: "Google Reviews" };
export const REVIEWS = [
  { name: "K S", reviewCount: "3 reviews", when: "2 months ago", initials: "KS", color: "#6C2B77", text: "Every now and then you come across a business that's simply operating on another level and Aware Hub is one of them. The reception team is, without question, one of the most professional, efficient and genuinely caring teams I've ever dealt with. It doesn't matter who answers the phone or greets you at reception; every interaction is seamless, kind and incredibly well organised. As patients, we often thank our doctors, but it's the reception team who keep everything running so effortlessly behind the scenes. They deserve to be recognised because they truly are exceptional. The care, professionalism and attention to detail shown by everyone at Aware Hub create an environment where you feel genuinely supported from the moment you arrive. Thank you to the entire team." },
  { name: "Charlie Harvey", reviewCount: "4 reviews", when: "11 months ago", initials: "CH", color: "#0F9D8F", text: "I can't thank Dr Lisa Myers enough for the difference she's made in my life. She's incredibly passionate about what she does and genuinely cares about her patients. From the first session, she helped me unpack and deal with problems I'd been struggling with for years. The clinic feels calm and welcoming, and the team is always kind and professional. I also tried the TMS treatment here, and it honestly works wonders — it's made a huge improvement to my mood and clarity. If you're looking for real, compassionate support from someone who truly listens and knows her stuff, I couldn't recommend Dr Myers and her clinic more highly." },
  { name: "Sarah Levy", reviewCount: "Local Guide · 29 reviews", when: "11 months ago", initials: "SL", color: "#1E2B5F", text: "The team at Aware Hub are absolutely amazing! I'm currently doing esketamine therapy & have the whole team involved including the nurses who are so beautiful & caring. Dr Lisa Myers is such a lovely, proactive psychiatrist who genuinely cares about her clients. She makes you feel so supported because she takes the time to listen & get to know you well. I've found Dr Myers to be quite flexible & very understanding if something comes up & your plans change which isn't always the case. Just an all round gem of a Psychiatrist & cannot recommend enough. I've also had the pleasure of working very closely with Romy for some trauma therapy & that has also been absolutely amazing. Can't recommend Aware Hub enough! Thank you for helping me better my life." },
  { name: "Steve Alpe", reviewCount: "6 reviews", when: "4 years ago", initials: "SA", color: "#017477", text: "Dr Lisa Myers is a fantastic psychiatrist and also a wonderful person. I've been a client of Lisa's for over 7 years now and she has been there to help guide me through the darkest times in my life and has been there all the way to watch me grow to where I am currently and keep me on track. Not only is she great from the medication point of view; she's phenomenal when it comes to therapy. She enables you to feel comfortable to open up, bear all and show your vulnerabilities which enables us to work closely together. The stunning new AwareHub location gives you a warm and relaxing environment to walk into rather than a stagnant clinical feel like many therapist rooms. Lisa tells me what I need to hear not just what I want to hear and I thank her for that. 5* - Recommend Highly" },
  { name: "Melanie Bishop", reviewCount: "1 review", when: "a year ago", initials: "MB", color: "#C2410C", text: "Absolutely fabulous psychiatrist. Lisa listens and understands your concerns and is always moving to help you resolve the concerns. She is up to date with the most recent best practices and passes this onto the patient. Always friendly and approachable and treats you as a person and is so respectful. The nurses are always happy and friendly. They always ensure your comfort and address issues if you are concerned. An excellent standard of service and highly recommended." },
  { name: "Josh", reviewCount: "7 reviews", when: "a year ago", initials: "J", color: "#2E7D32", text: "As a long-term patient of Lisa and the Awarehub team, I can confidently say that Lisa is an exceptional psychiatrist and the entire Awarehub staff are fantastic. Lisa's profound knowledge, understanding, and kindness have been instrumental in my care. The Awarehub environment; which includes other mental health related practitioners along with diverse treatment options, has been thoughtfully cultivated to provide excellent care in one setting. I always feel relaxed when entering the space." },
  { name: "Kvn Ltn", reviewCount: "5 reviews", when: "2 years ago", initials: "KL", color: "#6A1B9A", text: "The team at Awarehub have been a tremendous support to me over the past few years. As a long term patient the level of care has been consistently high. Lisa is an extremely caring doctor and was instrumental in my recovery from PTSD. Part of my treatment has involved RTMS and the nursing team that perform this treatment has been caring and professional. You will battle to find a better team of mental health professionals." },
  { name: "Naomi Tosic", reviewCount: "Local Guide · 20 reviews", when: "4 years ago", initials: "NT", color: "#00838F", text: "I cannot say enough positive things about Lisa and her team but I will try. As a psychiatrist, Lisa is personable, perceptive, professional, and a great problem solver. She has been a brilliant advocate for my son Quinn. Lisa has assembled an amazing team around, from her receptionists, practice manager, psychologist, art therapists and now an exercise physiologist. We love their new practice on Newland Street, and their unique and innovative approach to holistic health care. I highly recommend this practice to anyone seeking care for themselves or their family members." },
  { name: "Peter de Winter", reviewCount: "10 reviews", when: "3 years ago", initials: "P", color: "#5B6570", text: "Dr Lisa Myers is an outstanding physchiatrist; an ultimate professional, empathetic, warm, kind and very communicative. Together with her outstanding team of supporting staff and trained, experienced nurses, Lisa is responsible for consistent, sustained improvement in the mental health condition of her patients. I have seen for myself first hand the outstanding results she achieves. Her authoritative use of groundbreaking TMS treatment stands out as a life changing treatment. We are so grateful for Lisa and her teams support." },
  { name: "Kyle Bugelli", reviewCount: "3 reviews", when: "a year ago", initials: "KB", color: "#B8860B", text: "A big thank you to Dr Lisa Myers and her team at Bundaberg. They go above and beyond in all aspects. Dr Lisa Myers knowledge in psychiatry is next level and gives me great relief knowing I'm on the right track after going down many roads. Thanks again to Dr Lisa Myers and her Team." },
  { name: "Carla", reviewCount: "1 review", when: "11 months ago", initials: "C", color: "#1E2B5F", text: "Awarehub is a great clinic with a genuinely caring and professional team. They really take the time to get to know you and make sure the support fits your needs. You always feel respected and well looked after here!" },
  { name: "Andrew", reviewCount: "11 reviews", when: "a year ago", initials: "A", color: "#C2410C", text: "Dr. Lisa was very attentive to my concerns, thorough and compassionate to my situation. She has great communication skills and was genuinely interested in my case. The staff are friendly and efficient." },
];

export const CONTACT_INTRO = {
  heading: "Contact us today to arrange a FREE 15-minute call with one of our experienced nurses to discuss TMS and Esketamine and how they may support your mental health treatment.",
  body: "",
};

export const ESKETAMINE_PAGE = {
  eyebrow: "Esketamine (Spravato®)",
  title: "Advanced Treatment for Treatment-Resistant Depression",
  intro:
    "Esketamine (Spravato®) is a TGA-approved prescription nasal spray administered alongside an oral antidepressant for adults living with treatment-resistant depression. For clients who continue to experience significant depressive symptoms despite trying multiple conventional antidepressants, esketamine offers an evidence-based alternative pathway.",
  howTitle: "How Esketamine Works",
  howBody:
    "Unlike traditional antidepressants that target serotonin or noradrenaline pathways, esketamine acts on the brain's glutamate system. This specific mode of action helps enhance neuroplasticity (brain growth and change) and improve mood in clients who haven't responded to standard depression treatments.",
  suitableTitle: "Is Esketamine Right for You?",
  suitableIntro: "Esketamine may be considered for adults who:",
  suitable: [
    "Have a diagnosis of Major Depressive Disorder (MDD).",
    "Have not achieved adequate relief after trialling two or more antidepressant treatments.",
    "Continue to experience functional impairment due to persistent symptoms.",
    "Can attend regular in-clinic administration and observation sessions.",
  ],
  suitableNote:
    "Our psychiatrist will determine your suitability for esketamine through a comprehensive clinical assessment.",
  expectTitle: "What to Expect During Treatment",
  expectIntro:
    "Esketamine is administered exclusively within a controlled clinical environment under medical oversight.",
  expect: [
    { h: "In-Clinic Administration", b: "The medication is self-administered as a nasal spray under direct nursing supervision." },
    { h: "2-Hour Monitoring Period", b: "You will relax comfortably in a quiet room at the clinic for approximately one to two hours following administration." },
    { h: "Post-Treatment Precautions", b: "Due to the sedative effects of esketamine, you must arrange transport home and refrain from driving or operating heavy machinery until the next day." },
  ],
  protocolTitle: "Treatment Protocol & Schedule",
  protocolIntro: "Treatment is delivered in structured phases, tailored to your clinical response:",
  protocol: [
    { h: "Induction Phase (Weeks 1–4)", b: "Involves 2 sessions per week, 48–72 hours apart." },
    { h: "Optimisation Phase (Weeks 5-8)", b: "Transitions to 1 session per week." },
    { h: "Maintenance Phase", b: "If you have responded to esketamine, you may be eligible for maintenance treatment. Sessions are tapered to weekly or fortnightly based on your ongoing clinical need." },
  ],
  accessTitle: "Accessing Care",
  accessBody: [
    "Please ask your GP or psychiatrist to send a referral for an initial psychiatric assessment at AwareHub. Our clinical team will collaborate with your referring doctor throughout your care to support your long-term health plan.",
    "Please note that Medicare does not cover Esketamine treatment sessions; however, all your psychiatry reviews are billed at our standard clinic fees, and Medicare rebates will apply. The fee for esketamine treatment covers treatment administration and a two-hour observation period by our experienced nursing team.",
  ],
  disclaimerTitle: "Medical Disclaimer & Regulatory Notice",
  disclaimer:
    "Spravato® (esketamine) is a Schedule 8 prescription medicine indicated for adults with Treatment-Resistant Depression. It is available strictly under the care and supervision of an AHPRA-registered specialist psychiatrist. Treatment suitability, dosing, and protocols are determined following a comprehensive clinical evaluation. Individual outcomes vary. In accordance with TGA guidelines, esketamine must be administered in an accredited clinical setting under direct medical observation, and patients must not drive or operate machinery until the day after treatment. This page is intended for general educational purposes and does not replace professional medical advice.",
};

export const ACCELERATED_TMS_PAGE = {
  eyebrow: "Accelerated TMS (Transcranial Magnetic Stimulation)",
  title: "Intensive, Rapid-Acting Therapy for Depression",
  intro:
    "Accelerated TMS is an advanced, high-density form of Transcranial Magnetic Stimulation designed for fast symptom relief. Rather than spreading treatment across six to eight weeks with single daily visits, this protocol delivers concentrated, short sessions throughout the day—allowing you to complete a comprehensive course of treatment in a shorter time.",
  protocolTitle: "Example: The 5-Day Intensive Protocol",
  protocolIntro:
    "One of our accelerated programs provides 50 total treatment sessions condensed into 5 consecutive days:",
  protocol: [
    { h: "Hourly Sessions", b: "Clients complete three 3-minute intermittent Theta Burst Stimulation (iTBS) sessions per hour (totalling 9 minutes of active treatment per hour)." },
    { h: "Daily Volume", b: "The 9-minute treatment blocks are repeated 10 times per day for 5 days." },
    { h: "Clinic Comfort", b: "Between each treatment, clients can relax in our comfortable clinic." },
  ],
  itbsNote:
    "Understanding iTBS: Intermittent Theta Burst Stimulation (iTBS) is a TMS protocol that offers brief, highly focused stimulation, mimicking the brain's natural neuroplastic learning patterns.",
  advantagesTitle: "Key Advantages of Accelerated TMS",
  advantages: [
    { h: "Fast Symptom Relief", b: "Clients may notice improvements in their mood within days instead of waiting weeks." },
    { h: "Minimal Schedule Disruption", b: "You complete your full therapeutic program in a shorter time, eliminating the need for daily clinic commutes over multiple weeks." },
    { h: "Clinically Validated", b: "Research supports the efficacy of accelerated TMS for treatment-resistant depression." },
    { h: "High-Volume Delivery", b: "For the 5-day intensive protocol, each session provides a triple-dose (1,800 pulses), delivering the full therapeutic equivalent of a standard 6-week course in 5 days." },
    { h: "Proven Safety Profile", b: "Shares the same non-invasive, well-tolerated safety record as standard daily TMS treatments." },
  ],
  candidateTitle: "Who Is an Ideal Candidate?",
  candidateIntro:
    "Accelerated TMS may be suitable for adults with treatment-resistant depression who:",
  candidate: [
    "Require fast-acting clinical intervention due to significant symptom severity or everyday life disruption.",
    "Cannot accommodate a 6-week daily treatment schedule due to work commitments, travel, or distance.",
    "Can spend time relaxing at our clinic between treatments.",
    "Are evaluated and cleared for suitability by our specialist psychiatrist.",
  ],
  mappingTitle: "Personalised Care & Mapping Technology",
  mappingSubtitle: "Evidence-Based Targeting Without Costly Imaging",
  mappingBody: [
    "The 5-Day Accelerated Protocol is based on treatment frameworks established in major university research (such as the Stanford Neuromodulation Therapy / SNT protocol*).",
    "To locate the treatment target area, our clinic utilises the clinically verified Beam F3 mathematical mapping system rather than functional MRI (fMRI) scans. Large-scale clinical data confirms that non-MRI mathematical localisation achieves identical remission and recovery rates to high-tech MRI neuronavigation—delivering the exact same clinical results without charging patients thousands of dollars in extra imaging fees.",
  ],
  mappingNote: "*Note: SNT was formerly known as Stanford Accelerated Intelligent Neuromodulation Therapy (SAINT).",
  tailoredTitle: "Tailored to Your Needs",
  tailoredBody:
    "While the 5-day protocol is an established option, every person responds differently. Client safety, comfort, and clinical progress are always our top priorities. If needed, our clinical team may suggest a variation of this condensed schedule to ensure optimal comfort and therapeutic efficacy.",
  referencesTitle: "Scientific Research & References",
  references: [
    {
      text: "Stanford 5-Day Accelerated TMS (SNT) — Cole et al., 2022. A double-blind randomised controlled trial: after five days, 78.6% of participants receiving SNT were no longer depressed according to the study's evaluation methods.",
      links: [
        { label: "PubMed — Cole et al. 2022", url: "https://pubmed.ncbi.nlm.nih.gov/34711062/" },
        { label: "Stanford Medicine — study summary", url: "https://med.stanford.edu/news/all-news/2021/10/depression-treatment.html" },
      ],
    },
    {
      text: "Beam F3 vs MRI-neuronavigation — Mir-Moghtadaei et al., 2015. Beam F3 and MRI-guided targeting were highly concordant: the discrepancy was <0.65 cm in 50%, <0.99 cm in 75%, and <1.36 cm in 95% of subjects.",
      links: [
        { label: "PubMed Central — Full article", url: "https://pmc.ncbi.nlm.nih.gov/articles/PMC4833442/" },
      ],
    },
    {
      text: "Beam F3 clinical outcomes — Trapp et al., 2023. A randomised controlled trial published in Brain Stimulation found that Beam F3 targeting produced similar antidepressant outcomes to the conventional 5.5-cm targeting method, supporting Beam F3 as an effective clinical targeting approach.",
      links: [
        { label: "Brain Stimulation — Trapp et al. 2023", url: "https://doi.org/10.1016/j.brs.2023.09.006" },
      ],
    },
  ],
};

export const FAQ_INTRO_CLOSING = "Please reach out to us at AwareHub if you cannot find an answer to your question.";

export const FAQ_SECTIONS = {
  general: {
    key: "general",
    title: "General Questions",
    faqs: [
      {
        q: "How do I make an appointment for TMS or Esketamine at AwareHub?",
        a: [
          "Both TMS and Esketamine (Spravato®) are specialised psychiatric treatments that require a referral from your GP or psychiatrist before your initial consultation.",
          "To get started: Ask your doctor or psychiatrist to send a referral addressed to AwareHub. Email your referral to TMS@awarehub.com.au or contact our team directly at 1300 0 AWARE (1300 029 273) if you have any questions or need further information. Once we receive your referral, our clinical intake team will reach out within 48 hours to book your initial specialist assessment.",
        ],
      },
      {
        q: "What is your cancellation policy?",
        a: ["We require at least 2 business days' notice to cancel or reschedule an appointment. Late cancellations or missed appointments may incur the full appointment fee."],
      },
      {
        q: "Can I bring a support person?",
        a: ["Yes, in most cases you are welcome to bring a family member, carer, or support person. Please contact us if you would like to arrange bringing a support person with you for Esketamine treatment."],
      },
      {
        q: "What should I do in an emergency or crisis?",
        a: ["AwareHub is an outpatient clinic and does not provide immediate emergency or crisis care. If you require urgent assistance, please call 000, contact Lifeline on 13 11 14, your GP or present to your nearest hospital emergency department."],
      },
    ],
  },
  tms: {
    key: "tms",
    title: "TMS",
    faqs: [
      {
        q: "Why Choose TMS?",
        a: ["Transcranial Magnetic Stimulation (TMS) has the Australian Therapeutic Goods Administration's (TGA) approval as a treatment for resistant depression and obsessive-compulsive disorder (OCD). TMS has also demonstrated efficacy in treating anxiety, PTSD, migraines, substance disorders, chronic pain, nerve pain, dementia and symptoms of autism spectrum disorder (ASD). TMS is an excellent option if medication has not been effective or well tolerated due to side effects. TMS is most effective when combined with a healthy lifestyle. TMS demonstrates a 70% response rate in depression treatment. It is a cost-effective and revolutionary treatment that improves brain functioning and connectivity and stimulates neuroplasticity."],
      },
      {
        q: "Quick Facts about TMS",
        list: [
          "Safe",
          "Convenient",
          "Fewer side effects than most medications",
          "No personality changes or cognitive side effects",
          "Fast",
          "Cost-effective",
          "TGA approved",
          "Bulk-billed for treatment-resistant depression and no out-of-pocket fees apply",
          "Widespread use and efficacy",
          "Observed benefits in chronic pain, tinnitus, substance use, cerebral palsy, dementia, PTSD, ADHD, ASD",
        ],
      },
      {
        q: "How Does TMS Work?",
        a: ["Transcranial Magnetic Stimulation (TMS) works by using targeted magnetic pulses to stimulate or calm specific regions of the brain. High-frequency TMS stimulates brain activity, while low-frequency TMS calms overactive areas. By rebalancing brain activity in key neural networks, TMS helps restore healthy brain function and relieve psychiatric symptoms."],
      },
      {
        q: "Key Mechanisms of TMS Care",
        list: [
          "Stimulating Neuroplasticity: TMS encourages the brain to form new neural connections and strengthen existing pathways, promoting long-term recovery.",
          "Targeting Depression at the Source: In patients with depression, activity in the left frontal region of the brain—the dorsolateral prefrontal cortex—is typically reduced. High-frequency TMS targets this specific area to restore normal activity levels and relieve depressive symptoms.",
          "Clinically Proven & Safe: TMS is supported by extensive international research, including major trials by the National Institute of Mental Health (NIMH). With over 15 years of widespread clinical use and hundreds of studies confirming its efficacy, TMS is a well-established, non-invasive treatment option.",
        ],
      },
      {
        q: "How Does TMS Help with OCD?",
        a: ["TMS for OCD works by targeting the deeper neural networks involved in obsessive thoughts and compulsive behaviors (specifically the anterior cingulate cortex). Using specialised, deep-targeting magnetic coils, TMS delivers focused pulses to calm hyperactive brain circuits and encourage healthy neuroplasticity. Clinical trials show that up to 2 in 3 patients with hard-to-treat OCD experience significant symptom reduction following a structured course of Deep TMS."],
      },
      {
        q: "Who is suitable for TMS treatment?",
        a: ["TMS is primarily indicated for adults living with treatment-resistant depression, anxiety, or OCD who have not achieved adequate relief from standard oral medications or therapy, or who experience intolerable medication side effects."],
      },
      {
        q: "How many sessions will I need?",
        a: ["A standard acute course for depression typically consists of up to 35 sessions delivered over 4 to 6 weeks, followed by a gradual tapering schedule to maintain progress. We also offer various accelerated protocols for clients wanting to shorten their course of treatment, e.g. an Accelerated 5-Day TMS Protocol (50 sessions over 5 days) for eligible patients."],
      },
      {
        q: "Are there side effects with TMS?",
        a: ["TMS is well-tolerated with minimal side effects. The most common side effect is mild, temporary scalp discomfort or a light headache during the first week of treatment, which typically resolves quickly. Unlike medication, TMS does not cause systemic side effects like weight gain or nausea, and unlike ECT, it does not affect memory."],
      },
      {
        q: "Is TMS Safe During Pregnancy?",
        a: ["Yes. Current clinical research indicates that Transcranial Magnetic Stimulation (TMS) is a safe and effective treatment option during all trimesters of pregnancy. Because TMS is a non-invasive, medication-free treatment, it provides a vital alternative for managing Major Depressive Disorder (MDD) without exposing the developing foetus to pharmacological side effects."],
      },
      {
        q: "Why Treating Depression During Pregnancy Matters",
        a: ["Depression affects an estimated 13% of pregnant women. Unmanaged maternal depression carries significant health risks for both mother and baby, including:"],
        list: [
          "Higher rates of pregnancy complications (such as preterm birth, low birth weight, and pre-eclampsia).",
          "Reduced engagement with essential prenatal care.",
          "Long-term impacts on maternal-infant bonding and early childhood development.",
        ],
      },
      {
        q: "What Clinical Research Shows",
        list: [
          "Safe Across All Trimesters: Extensive literature reviews show that both high- and low-frequency TMS can be safely administered at any stage of pregnancy.",
          "No Known Foetal Risk: There is no evidence suggesting detrimental effects on foetal development, as the magnetic field is targeted specifically to the mother's brain and does not reach the abdomen.",
          "Significant Symptom Relief: Studies demonstrate robust reductions in depressive symptoms, offering new hope when traditional medications are undesirable or ineffective.",
        ],
      },
      {
        q: "Clinical Evaluation & Care",
        a: ["Every pregnancy is unique. At AwareHub, treatment suitability for pregnant patients is thoroughly assessed by our specialist psychiatrists in consultation with your obstetric care team."],
      },
      {
        q: "How is TMS different to ECT?",
        a: ["Electro-convulsive therapy (ECT) entails electrically induced seizures given under an anaesthetic in hospital. However, TMS therapy is conducted in the clinic and it stimulates brain regions using brief magnetic pulses at an amplitude similar to that used in MRI systems. ECT may cause severe side effects, including memory loss, while TMS has no negative effects on memory, and is generally well-tolerated."],
      },
      {
        q: "Is TMS different to medications?",
        a: ["Yes. TMS is a drug-free treatment that has less side effects than antidepressants. TMS is often effective when medications have failed. TMS can be stopped at any time with no withdrawal symptoms."],
      },
      {
        q: "How will I know TMS is working?",
        a: ["Your presenting symptoms will start to improve and others might remark that you appear better. Your scores on standardised questionnaires of mood and anxiety will also demonstrate an improvement."],
      },
      {
        q: "Quick facts about the procedure?",
        list: [
          "TMS causes minimal discomfort.",
          "You remain awake and alert through the procedure.",
          "You can read, rest and relax or talk to the clinician throughout your treatment.",
          "You can resume activities directly following the treatment.",
          "During the treatment you will hear a clicking noise and feel a tapping sensation on your scalp.",
          "A clinician will always be with you.",
          "You can stop the treatment at any time.",
        ],
      },
      {
        q: "Do I still need my medication?",
        a: ["Yes, unless advised otherwise, you should remain on your medication for the duration of the treatment. Medication is helpful to prevent relapse following the tapering and cessation of TMS. There are instances where medication can be reduced and ceased whilst undergoing TMS. Medications can also be switched whilst undergoing TMS and new options of treatment can be trialed. Any stopping of medication or changes to your current treatment need to be done in consultation with your treating doctor."],
      },
      {
        q: "Do I need to consult my doctor?",
        a: ["Yes, your psychiatrist and/or GP remain responsible for your care. Our team will be responsible for administering and overseeing your TMS treatment. We will provide your doctor with regular written updates regarding your treatment. Your treating doctor remains your primary contact person, but you should always raise any concerns regarding your TMS treatment with one of our team members."],
      },
    ],
  },
  acceleratedTms: {
    key: "acceleratedTms",
    title: "Accelerated TMS",
    faqs: [
      {
        q: "What is Accelerated TMS?",
        a: ["Accelerated TMS is a way of delivering a full therapeutic course of TMS over days rather than weeks, by giving multiple treatment sessions per day. The best-known example is the Stanford Accelerated Intelligent Neuromodulation Therapy approach (SAINT). This highly intensive form of accelerated TMS for treatment-resistant depression offers 10 treatments per day over 5 days."],
      },
      {
        q: "How is Accelerated TMS different from standard TMS?",
        a: ["In simple terms, standard TMS for depression might be one session per day, 5 days per week for 4-6 weeks. Whereas, accelerated TMS might be 5-10 sessions per day delivered over 5 consecutive days."],
      },
      {
        q: "Who may be suitable for Accelerated TMS?",
        a: ["Accelerated TMS is mainly suited to adults with major depressive disorder who need a rapid treatment response, particularly when conventional treatments haven't worked adequately, including conventional TMS. It may also suit people who cannot commit to 4-6 weeks of daily conventional TMS. A clinical assessment is required to determine whether Accelerated TMS is appropriate for you."],
      },
      {
        q: "How long does Accelerated TMS treatment take?",
        a: ["Treatment involves several (3-10 per day) short treatment sessions each day (9 minutes), with breaks between sessions (50 minutes), over considerably fewer days than conventional TMS (5-10 days). One of AwareHub's accelerated protocols provides 50 treatment sessions over 5 consecutive days, however variations of this protocol have been applied successfully."],
      },
      {
        q: "Does Accelerated TMS hurt?",
        a: ["TMS is non-invasive and does not require anaesthesia or sedation. During treatment, you may feel a tapping sensation on the scalp. Some people experience temporary scalp discomfort or a mild headache, particularly early in treatment, but TMS is generally well tolerated."],
      },
      {
        q: "Can I drive after Accelerated TMS treatment?",
        a: ["Most people can return to their usual activities, including driving, after TMS treatment."],
      },
      {
        q: "How quickly will I notice an improvement?",
        a: ["Response to treatment varies from person to person. Some people may notice an improvement in their mood during the accelerated treatment course, while for others improvement may occur more gradually. Your progress will be monitored throughout treatment."],
      },
      {
        q: "Is Accelerated TMS as effective as standard TMS?",
        a: ["Yes, the evidence so far suggests that accelerated TMS can be about as effective as conventional daily TMS for depression. Some protocols may be more effective than others. A 2023 meta-analysis of randomized and controlled studies found no significant difference in antidepressant efficacy between accelerated and standard TMS, while the accelerated TMS produced improvement more quickly. Your clinician will discuss the available evidence and whether the accelerated protocol is suitable for you."],
      },
      {
        q: "What happens during an Accelerated TMS treatment day?",
        a: ["You will attend the clinic for several hours, with a number of short TMS sessions delivered throughout the day and scheduled breaks in between. During the breaks, you are welcome to relax comfortably at the clinic, take a short walk outside for fresh air or enjoy a snack."],
      },
    ],
  },

  esketamine: {
    key: "esketamine",
    title: "Esketamine",
    faqs: [
      {
        q: "What is Esketamine therapy?",
        a: ["Esketamine is a TGA-approved prescription nasal spray administered alongside an oral antidepressant for adults with treatment-resistant depression. It acts on the brain's glutamate pathways to help restore neural connections and improve mood."],
      },
      {
        q: "How is Esketamine administered?",
        a: ["Esketamine is self-administered as a nasal spray strictly within our clinic under direct medical and nursing supervision."],
      },
      {
        q: "Why is there a 2-hour observation period?",
        a: ["Following administration, patients relax comfortably in our clinic for approximately two hours while registered nurses monitor blood pressure and vital signs to ensure safety as temporary effects (such as mild dissociation or fatigue) wear off."],
      },
      {
        q: "Can I drive home after an Esketamine session?",
        a: ["No. Due to temporary drowsiness or light-headedness, you must arrange transport home with a friend, family member, or ride-share service, and you must not drive or operate machinery until the following day."],
      },
      {
        q: "Is Esketamine covered by Medicare?",
        a: ["Unfortunately, Esketamine treatment does not have a Medicare item number and is therefore billed privately. This fee covers Esketamine administration and clinical monitoring at the clinic. In addition to the monitoring fee, a dispensing fee of $25.00 applies for a month's supply of Esketamine ($7.70 for concession card holders). Any consultations with our doctor are billed at the standard clinic fee, with applicable Medicare rebates available."],
      },
    ],
  },
  feesInsurance: {
    key: "feesInsurance",
    title: "Fees & Insurance",
    faqs: [
      {
        q: "Is TMS covered by Medicare?",
        a: ["Yes. Initial courses of TMS for treatment-resistant depression are fully bulk-billed under Medicare for eligible patients 18 and older (up to 35 sessions), meaning no out-of-pocket costs for these treatment sessions. Psychiatrist assessment and review consultations attract Medicare rebates."],
      },
      {
        q: "Are DVA, Workcover, or NDIS accepted?",
        a: ["Yes. AwareHub is a registered NDIS provider. We also accept eligible DVA cardholders and approved Workcover (including iCare NSW and Workcover QLD) claims for structured treatment programs like TMS and Esketamine."],
      },
      {
        q: "What is the cost of Accelerated TMS?",
        a: ["Because Medicare limits daily billable session limits, 15 sessions in the 5-day accelerated protocol fall outside standard Medicare coverage. The remaining 35 sessions are bulk-billed, capping the total patient out-of-pocket cost at $750 for the full 50-session course."],
      },
    ],
  },
};

export const FAQ_PAGE_ORDER = ["general", "tms", "acceleratedTms", "esketamine", "feesInsurance"];

